import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import {
    HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/** Passes HttpErrorResponse to application-wide error handler */
@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private injector: Injector,
    private translateService: TranslateService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          // const appErrorHandler = this.injector.get(ErrorHandler);
          // appErrorHandler.handleError(err);
          if (err.error) {
            return throwError(err.error);
          } else if (err.status === 403) {
            return throwError(this.translateService.instant('Accesso negato'));
          } else {
            return throwError(
              this.translateService.instant(
                'Si è verificato un errore imprevisto'
              )
            );
          }
        }
      })
    );
  }
}
